var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9059 5.41536L18.5846 6.09408L6.09406 18.5837L5.41534 17.9054L17.9059 5.41536Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09406 5.41536L18.5846 17.905L17.9059 18.5842L5.41534 6.09456L6.09406 5.41536Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu_close.7cbfc25750ec7bdde7b6e55cb0f0b5a4.svg";
export { ForwardRef as ReactComponent };